import { createTableExport } from 'api/Export';

import { showAlert } from 'components/shared/Alert/Alert';

const FORMATS = ['csv', 'excel', 'pdf'];

const formatNames = (results) => results.map(({ format }) => format.toUpperCase()).join(', ');

export const queueTableExport = async ({
  navigate,
  values,
  finalColumns,
  dataset,
  datasetParams,
  statusPanelData,
  exportApiProps,
  totalRows
}) => {
  const formats = FORMATS.filter((format) => values.export_type.includes(format));

  // Each format is its own job, so one failing must not hide the ones that did queue.
  const results = await Promise.all(
    formats.map(async (format) => {
      try {
        const response = await createTableExport(navigate, {
          dataset,
          format,
          // `pdfFormat` overrides `exportFormat` in the PDF writer only, so a column can
          // render a label in the PDF while CSV/Excel keep the raw stored value.
          columns: finalColumns.map(({ field, headerName, exportFormat, pdfFormat }) => ({
            field,
            headerName,
            exportFormat,
            pdfFormat
          })),
          title: values.title,
          orientation: values.orientation,
          statusPanelData,
          category: exportApiProps?.category,
          datasetParams
        });

        return { format, response, ok: response?.code === 0 };
      } catch (error) {
        return { format, error, ok: false };
      }
    })
  );

  const queued = results.filter(({ ok }) => ok);
  const failed = results.filter(({ ok }) => !ok);

  if (!queued.length) {
    showAlert({
      title: failed[0]?.response?.error || 'Export could not be queued',
      color: 'danger'
    });
    return false;
  }

  if (failed.length) {
    showAlert({
      title: `${formatNames(queued)} queued, ${formatNames(failed)} failed`,
      message: `You'll be notified when the ${
        queued.length > 1 ? 'files are' : 'file is'
      } ready to download. Try the failed ${failed.length > 1 ? 'formats' : 'format'} again.`,
      color: 'warning'
    });
    return true;
  }

  showAlert({
    title: `Preparing ${Number(totalRows).toLocaleString()} rows`,
    message: `You'll be notified when the ${
      queued.length > 1 ? 'files are' : 'file is'
    } ready to download.`,
    color: 'success'
  });

  return true;
};
